import { withInstall } from '../../../../utils/with-install'
import Satellite from './Satellite.vue'

export const ElAmapLayerSatellite = withInstall(Satellite)
export default ElAmapLayerSatellite
